import { all, call, put, takeLatest } from "redux-saga/effects";
import { GUI_EMAIL } from "actions/GuiEmail/actionTypes";
import { guiEmailSuccess, guiEmailFailure } from "actions/GuiEmail";
import GuiEmailApi from "service/guiEmailApi";
import { pushNotification } from "utils/notifications";

function* guiEmail(action) {
  try {
    const response = yield call(GuiEmailApi.guiEmail, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(guiEmailFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(guiEmailSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(guiEmailFailure());
    }
  } catch (error) {
    yield put(guiEmailFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GUI_EMAIL, guiEmail);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
